import React from 'react';
import { useTranslation } from 'react-i18next';
import TermsOfService from './TermsOfService';

const TermsOfServiceModal = ({ onAccept }) => {
    const { t } = useTranslation();

    return (
        <div className="modal-overlay">
            <div className="bg-gray-900 rounded-lg p-6 max-w-3xl w-full h-3/4 flex flex-col">
                <div className="overflow-y-auto custom-scrollbar pr-4">
                    <TermsOfService />
                </div>
                <div className="mt-6 text-center">
                    <button onClick={onAccept} className="cosmic-button bg-green-500/20 border-green-400 text-green-300 hover:bg-green-500/40 hover:shadow-green-400/50">
                        {t('termsOfServiceModal.acceptAndContinue')}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TermsOfServiceModal;
